import React from 'react';
import { StandardHeader } from './StandardHeader';

interface PublicHeaderProps {
  /** Use transparent/dark variant for dark hero sections */
  transparent?: boolean;
  /** Overlay mode — header sits over page content (for landing hero) */
  overlay?: boolean;
}

export function PublicHeader({ transparent = false, overlay = false }: PublicHeaderProps) {
  return <StandardHeader showNavigation={true} transparent={transparent} overlay={overlay} />;
}
